// ko strings for messages/nav.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const nav: Dict = {
  "nav.home": "홈",
  "nav.create": "만들기",
  "nav.voices": "목소리",
  "nav.train": "목소리 학습",
  "nav.library": "라이브러리",
  "nav.tab.profile": "프로필",
  "nav.404.seoTitle": "페이지를 찾을 수 없어요 | Jammable",
  "nav.404.title": "페이지를 찾을 수 없어요",
  "nav.404.body": "이 콘텐츠는 더 이상 없는 것 같아요.",
  "nav.404.home": "홈으로",
  "nav.404.browse": "목소리 둘러보기",
  "nav.404.discordLabel": "찾는 게 있나요?",
  "nav.404.discordBody": "Discord 커뮤니티에 물어보세요",
  "nav.pricing": "요금제",
  "nav.affiliate": "제휴 프로그램",
  "nav.api": "API",
  "nav.login": "로그인",
  "nav.signup": "회원가입",
  "nav.signupFree": "무료로 가입하기",
  "nav.getPlan": "요금제 선택",
  "nav.discordAria": "Jammable Discord 참여하기",
  "nav.discordJoin": "Discord 참여하기",
  "nav.openMenu": "메뉴 열기",
  "nav.closeMenu": "메뉴 닫기",

  // Greetings by time of day: 0 morning, 1 afternoon, 2 evening, 3 late night.
  "nav.greet.0.0": "일찍 일어나셨네요",
  "nav.greet.0.1": "좋은 아침이에요",
  "nav.greet.0.2": "안녕하세요",
  "nav.greet.0.3": "반가워요",
  "nav.greet.0.4": "오늘도 반가워요",
  "nav.greet.1.0": "안녕하세요",
  "nav.greet.1.1": "반가워요",
  "nav.greet.1.2": "좋은 오후예요",
  "nav.greet.1.3": "잘 지내셨어요?",
  "nav.greet.1.4": "어서 오세요",
  "nav.greet.2.0": "좋은 저녁이에요",
  "nav.greet.2.1": "반가워요",
  "nav.greet.2.2": "오늘 하루 어땠어요?",
  "nav.greet.2.3": "안녕하세요",
  "nav.greet.2.4": "어서 오세요",
  "nav.greet.3.0": "아직 안 주무세요?",
  "nav.greet.3.1": "올빼미족이시군요?",
  "nav.greet.3.2": "밤이 깊었네요",
  "nav.greet.3.3": "잠이 안 오세요?",
  "nav.greet.3.4": "늦은 밤이네요",
  "nav.profile.view": "프로필 보기",
  "nav.profile.credit": "크레딧",
  "nav.profile.credits": "크레딧",
  "nav.profile.voicePass": "Voice Pass",
  "nav.profile.voices": "목소리",
  "nav.profile.shop": "아이템 상점",
  "nav.profile.feedback": "의견 보내기",
  "nav.profile.settings": "설정",
  "nav.profile.apiDashboard": "API 대시보드",
  "nav.profile.signOut": "로그아웃",
  "nav.profile.signedOut": "로그아웃되었어요!",
  "nav.profile.avatarAlt": "사용자 아바타",

  // Footer
  "nav.footer.tagline":
    "10만 개 이상의 목소리로 만드는 AI 커버. 몇 초 만에 완성돼요.",
  "nav.footer.colCreate": "만들기",
  "nav.footer.colAccount": "계정",
  "nav.footer.colLegal": "법적 고지",
  "nav.footer.aiCover": "AI 커버 만들기",
  "nav.footer.voiceChanger": "AI 보이스 체인저",
  "nav.footer.voiceLibrary": "AI 목소리 라이브러리",
  "nav.footer.train": "목소리 학습",
  "nav.footer.weights": "Weights.gg 대안",
  "nav.footer.settings": "설정",
  "nav.footer.earn": "Jammable로 수익 내기",
  "nav.footer.mcp": "AI 에이전트용 MCP 서버",
  "nav.footer.forgot": "비밀번호 찾기",
  "nav.footer.terms": "이용약관",
  "nav.footer.privacy": "개인정보처리방침",
  "nav.footer.dmca": "DMCA 정책",
  "nav.footer.refunds": "환불 정책",
  // Rendered "<before> <link> <after>".
  "nav.footer.pitchmeldBefore": "음성 처리에",
  "nav.footer.pitchmeldLink": "Pitchmeld 기술",
  "nav.footer.pitchmeldAfter": "사용",

  "nav.language": "언어",
};

export default nav;
